/**
 * Registre centralisé des visuels du site.
 * Pour remplacer un visuel : importez votre fichier (idéalement ≥ 2400 px de large, lumineux, net)
 * et assignez-le au champ `src` correspondant. Un `src` vide affiche un fond neutre élégant.
 */
import heroImage from './bg.jpg';
import bankImage from '../Files/569 (1).jpg';
import microfinanceImage from '../Files/537.jpg';
import cooperativeImage from '../Files/coop.jpg';
import smeImage from '../Files/conseil.jpg';
import aboutImage from '../Files/pme.jpg';
import aiImage from '../Files/tn.jpg';
import ebMarketImage from '../Files/ebmarket.jpg';
import loanFlexImage from '../Files/loanflex.jpg';
import careerImage from '../Files/md.jpg';
import ebCallShotImage from "./ebCall/Capture d'écran 2026-09-29 154426.png";
import ebCollectImage from './ebcollect/Admin Home Page.png';
import threeWchatLogo from './3wchat/3wchat logo.svg';
import ebCollectLogo from './ebcollect/Icon ebCollect.svg';
import ebCallLogo from './ebCall/EBCallLogo.png';
import ebMarketLogo from './ebMarket/ebMarket Logo.png';

export interface ImageAsset {
    src?: string;
    alt: string;
}

export const Images = {
    hero: { src: heroImage, alt: 'IBG Alpha Technology' } as ImageAsset,
    about: { src: aboutImage, alt: 'Équipe IBG Alpha Technology' } as ImageAsset,
    ai: { src: aiImage, alt: 'Intelligence artificielle' } as ImageAsset,
    career: { src: careerImage, alt: 'Carrière chez IBG Alpha Technology' } as ImageAsset,
    pageHeroes: {
        about: { src: undefined, alt: 'À propos' } as ImageAsset,
        contact: { src: undefined, alt: 'Contact' } as ImageAsset,
        career: { src: undefined, alt: 'Carrière' } as ImageAsset,
        articles: { src: undefined, alt: 'Articles' } as ImageAsset,
    },
    targets: [
        { src: bankImage, alt: 'Banque' },
        { src: microfinanceImage, alt: 'Microfinance' },
        { src: cooperativeImage, alt: 'Coopérative' },
        { src: smeImage, alt: 'PME' },
    ] as ImageAsset[],
    products: [
        { src: ebCallShotImage, alt: 'eBCall' },
        { src: ebMarketImage, alt: 'eBMarket' },
        { src: loanFlexImage, alt: 'LoanFlex' },
        { src: ebCollectImage, alt: 'eBCollecte' },
        { src: threeWchatLogo, alt: '3wchat' },
    ] as ImageAsset[],
    productLogos: [
        { src: ebCallLogo, alt: 'eBCall' },
        { src: ebMarketLogo, alt: 'eBMarket' },
        { src: undefined, alt: 'LoanFlex' },
        { src: ebCollectLogo, alt: 'eBCollecte' },
        { src: threeWchatLogo, alt: '3wchat' },
    ] as ImageAsset[],
};
